import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/styles';
import { FC } from 'react';

import FiltersRow from 'Modules/Actions/containers/FiltersRow';
import CurrentTabZeroState from 'Modules/Actions/containers/ZeroStates/CurrentTab';
import PausedFlowsWarning from 'Modules/Shared/containers/PausedFlowsWarning';
import ChipsRow from 'Modules/Actions/containers/ChipsRow';
import TableTabs from 'Modules/Actions/containers/TableTabs';
import HeaderSection from 'Modules/Actions/containers/HeaderSection';
import ActionsTable from 'Modules/ActionsRewrite_2024/components/ActionsTable';

type ActionsTableEntryParams = {
  inLoadingState?: boolean;
};

const useStyles = makeStyles(_theme => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 24,
    justifyContent: 'flex-start',
  },
  pausedFlowContainer: {
    position: 'absolute',
    right: 22,
    top: 55,
  },
  fadeContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

const ActionsTableEntry: FC<ActionsTableEntryParams> = ({
  inLoadingState = false,
}) => {
  const classes = useStyles();

  // Below are temporary
  const arePausedFlows = true;
  // Figuring this out
  const shouldDisplayNoActionsZeroState = false;

  return (
    <>
      <div className={classes.headerContainer}>
        {/* TODO: PLAYB-173 / WFA-102: Rewrite these as Functional components */}
        {/* <HeaderSection /> */}
        {/* <ChipsRow /> */}
      </div>
      <Fade in={!inLoadingState} timeout={500}>
        <div className={classes.fadeContainer}>
          {/* {arePausedFlows && (
            <div className={classes.pausedFlowContainer}>
              <PausedFlowsWarning />
            </div>
          )} */}
          {/* TODO: swap out in PLAYB-156 / WFA-112 */}
          {/* <TableTabs /> */}
          {/* TODO: Swap out in PLAYB-158 / WFA-105 */}
          {/* <FiltersRow /> */}
          {shouldDisplayNoActionsZeroState ? (
            <CurrentTabZeroState />
          ) : (
            <ActionsTable />
          )}
        </div>
      </Fade>
    </>
  );
};

export default ActionsTableEntry;
